import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const StarOutlineIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m3 5.856-.472 2.752L5 7.309l2.472 1.299L7 5.856l2-1.95-2.764-.401L5 1 3.764 3.505 1 3.906l2 1.95Zm.578-.204L3.242 7.61 5 6.685l1.758.925-.336-1.958 1.423-1.386-1.966-.286-.88-1.78-.878 1.78-1.966.286 1.423 1.386Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const StarOutlineIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m3 5.856-.472 2.752L5 7.309l2.472 1.299L7 5.856l2-1.95-2.764-.401L5 1 3.764 3.505 1 3.906l2 1.95Zm.578-.204L3.242 7.61 5 6.685l1.758.925-.336-1.958 1.423-1.386-1.966-.286-.88-1.78-.878 1.78-1.966.286 1.423 1.386Z"
            />
        </SvgIcon>
    );
};
